<template>
  <div class="edit-item-release-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('editItemReleaseView.title')" :subtitle="$t('editItemReleaseView.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="updateItemReleaseInfo">
          {{ $t('common.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 放行信息面板 -->
    <div class="ds-panel">
      <el-form label-width="150px" label-position="right" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editItemReleaseView.releaseType')">
              <el-select v-model="editItemReleaseViewInfo.typeId" disabled class="w-full">
                <el-option disabled value="" :label="$t('editItemReleaseView.selectReleaseType')" />
                <template v-for="item in editItemReleaseViewInfo.itemReleaseTypes">
                  <el-option :key="item.typeId" :label="item.typeName" :value="item.typeId" v-if="item.state == 'C'" />
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editItemReleaseView.applyCompany')">
              <el-input v-model.trim="editItemReleaseViewInfo.applyCompany"
                :placeholder="$t('editItemReleaseView.inputApplyCompany')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editItemReleaseView.applyPerson')">
              <el-input v-model.trim="editItemReleaseViewInfo.applyPerson"
                :placeholder="$t('editItemReleaseView.inputApplyPerson')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editItemReleaseView.idCard')">
              <el-input v-model.trim="editItemReleaseViewInfo.idCard"
                :placeholder="$t('editItemReleaseView.inputIdCard')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editItemReleaseView.phone')">
              <el-input v-model.trim="editItemReleaseViewInfo.applyTel"
                :placeholder="$t('editItemReleaseView.inputPhone')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editItemReleaseView.passTime')">
              <el-date-picker v-model="editItemReleaseViewInfo.passTime" type="datetime" class="w-full"
                value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('editItemReleaseView.selectPassTime')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editItemReleaseView.carNum')">
              <el-input v-model.trim="editItemReleaseViewInfo.carNum"
                :placeholder="$t('editItemReleaseView.inputCarNum')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('editItemReleaseView.remark')">
              <el-input v-model.trim="editItemReleaseViewInfo.remark" type="textarea"
                :placeholder="$t('editItemReleaseView.inputRemark')" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- (3) 放行物品面板 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('editItemReleaseView.releaseItems') }}</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="addResName">
          {{ $t('editItemReleaseView.addItem') }}
        </el-button>
      </div>
      <ds-data-table :data="editItemReleaseViewInfo.resNames" border
        :empty-description="$t('editItemReleaseView.page.emptyItems')">
        <el-table-column :label="$t('editItemReleaseView.itemName')" align="center">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.resName" :placeholder="$t('editItemReleaseView.inputItemName')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('editItemReleaseView.itemAmount')" align="center">
          <template slot-scope="scope">
            <el-input v-model.trim="scope.row.amount" type="number"
              :placeholder="$t('editItemReleaseView.inputItemAmount')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="removeResName(scope.row.resName)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <!-- 表单操作区 -->
    <div class="ds-form-actions ds-form-actions--standalone">
      <el-button type="primary" icon="el-icon-check" @click="updateItemReleaseInfo">
        {{ $t('common.submit') }}
      </el-button>
      <el-button type="warning" icon="el-icon-close" @click="goBack">
        {{ $t('common.cancel') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import {
  updateItemRelease,
  listItemReleaseType,
  listItemRelease,
  listItemReleaseRes
} from '@/api/work/editItemReleaseViewApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'EditItemReleaseView',
  components: {
    DsPageHeader,
    DsDataTable
  },
  data() {
    return {
      editItemReleaseViewInfo: {
        irId: '',
        typeId: '',
        applyCompany: '',
        applyPerson: '',
        idCard: '',
        applyTel: '',
        passTime: '',
        resNames: [],
        state: '',
        carNum: '',
        remark: '',
        itemReleaseTypes: []
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.editItemReleaseViewInfo.irId = this.$route.query.irId
    this.listItemReleaseTypes()
    this.listItemReleases()
    this.loadItemReleaseRes()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    validateForm() {
      // 这里添加表单验证逻辑
      return true
    },
    async updateItemReleaseInfo() {
      if (!this.validateForm()) {
        return
      }

      try {
        this.editItemReleaseViewInfo.communityId = this.communityId
        const res = await updateItemRelease(this.editItemReleaseViewInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.goBack()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(this.$t('common.updateFailed'))
      }
    },
    async listItemReleaseTypes() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.communityId
        }
        const res = await listItemReleaseType(params)
        this.editItemReleaseViewInfo.itemReleaseTypes = res.data
      } catch (error) {
        console.error('Failed to fetch item release types:', error)
      }
    },
    addResName() {
      this.editItemReleaseViewInfo.resNames.push({
        resName: '',
        amount: ''
      })
    },
    removeResName(resName) {
      this.editItemReleaseViewInfo.resNames = this.editItemReleaseViewInfo.resNames.filter(
        item => item.resName !== resName
      )
    },
    async listItemReleases() {
      try {
        const params = {
          page: 1,
          row: 1,
          communityId: this.communityId,
          irId: this.editItemReleaseViewInfo.irId
        }
        const res = await listItemRelease(params)
        if (res.data && res.data.length > 0) {
          Object.assign(this.editItemReleaseViewInfo, res.data[0])
        }
      } catch (error) {
        console.error('Failed to fetch item releases:', error)
      }
    },
    async loadItemReleaseRes() {
      try {
        const params = {
          page: 1,
          row: 500,
          communityId: this.communityId,
          irId: this.editItemReleaseViewInfo.irId
        }
        const res = await listItemReleaseRes(params)
        this.editItemReleaseViewInfo.resNames = res.data
      } catch (error) {
        console.error('Failed to fetch item release resources:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-item-release-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);

  &--standalone {
    background: #fff;
    border: 1px solid var(--ds-gray-300);
    border-radius: var(--ds-radius-md);
    box-shadow: var(--ds-shadow-sm);
    padding: var(--ds-spacing-md) var(--ds-spacing-lg);
  }
}
</style>
